import { createNaturalMultiplicationTask, randInt, tableExplanation } from "./sharedNaturalMultiplication";

function pickData() {
  const a = randInt(2, 9);
  const b = randInt(2, 9);
  return { a, b, result: a * b };
}

const mod = createNaturalMultiplicationTask({
  type: "NaturalMulTableTask",
  pickData,
  explain: tableExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
